import { DETERMINAR_PAGINA_ATUAL_FECHAMENTO_CAIXA } from '../types'

export default function determinarPaginaAtualFechamentoCaixa (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_FECHAMENTO_CAIXA,
    payload: paginaAtual
  }
}
